import React from 'react'
import API from '../../utils/API';
import { FormattedMessage } from 'react-intl';

class SSOSignIn extends React.Component {
  state = {
    email: '',
    password: '',
    rememberMe: false,
    error: '',
    name: '',
    referrer: '',
  }

  handleChange = (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value
    this.setState({ [event.target.name]: value })
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      this.handleLogIn(event)
    }
  }

  errorMessage = (err) => {
    switch(err.response.status) {
      case 400:
        this.setState({ error: <FormattedMessage id="INVALID_PARAMETERS" /> })
        break;
      case 401:
      case 500:
        this.setState({ error: <FormattedMessage id={err.response.data.toUpperCase()} /> })
        break;
      default:
        this.setState({ error: err.message })
    }
    this.setConnectingStaus(false);
  }

  handleLogIn = (event) => {
    event.preventDefault()
    API.login({email: this.state.email, password: this.state.password})
    .then((val)=>{
      this.props.onSuccess();
    })
    .catch((err)=>{
      this.errorMessage(err);
    });
  }

  componentDidMount = () => {
    const search = new URLSearchParams(window.location.search)
    const referrer = search.get('referrer')
    this.setState({referrer});    
    if(referrer === null){
      this.setState({error: 'No referrer found. This route will do nothing when accessed directly'});
    }
  };

    render() {
        return(
            <div className='card'>
                <div className='form-outline mt-2 mb-2'>
                    <label className='form-label' htmlFor='form2Example1'><FormattedMessage id="EMAIL" /></label>
                    <input onChange={this.handleChange} value={this.state.email} name='email' type='email' className='form-control rounded-1' />
                </div>

                <div className='form-outline mb-2'>
                    <label className='form-label' htmlFor='form2Example2'><FormattedMessage id="PASSWORD" /></label>
                    <input type='password' onChange={this.handleChange} onKeyDown={this.handleKeyDown} value={this.state.password} name='password' className='form-control rounded-1' />
                </div>

                {this.state.error ? <p className='error'>{this.state.error}</p> : null}
                <button type='button' className='btn btn-primary btn-block' onClick={this.handleLogIn}><FormattedMessage id="LOG_IN" /></button>
            </div>
        )
    }
}

export default SSOSignIn;